import { useCallback } from "react";
import { useMISReportDownload } from "@hooks/useMISReportDownload";
import { MIS_FIELDS_PROBABILITYMONITORING } from "@constants/misDownloadData";
import { ATP_API_URL } from "@config/apiconfig";

export const useProbabilityMonitoringDownload = () => {
  const dataMapper = useCallback(
    (item) => ({
      "Sr No": item.sr_no,
      PNR: item.pnr || "-",
      "Train No": item.train_no || "-",
      "Travel Date": item.travel_date || "-",
      "Initial Probability (%)": item.initial_probability || "-",
      "Updated Probability (%)": item.updated_probability || "-",
      Timestamp: item.timestamp
        ? new Date(item.timestamp).toLocaleDateString()
        : "-",
      "Product Displayed (Y/N)": item.product_displayed || "-",
      "Auto Removal Triggered (Y/N)": item.auto_removal_triggered || "-",
    }),
    [],
  );

  return useMISReportDownload({
    reportType: "probability-monitoring",
    reportName: "Probability Monitoring",
    fields: MIS_FIELDS_PROBABILITYMONITORING,
    dataMapper,
    apiUrl: ATP_API_URL.MIS_PROBABILITY_MONITORING,
    sheetName: "Probability Monitoring",
  });
};

export default useProbabilityMonitoringDownload;
